import React, { createContext, useContext, useState, useCallback } from "react";

const AlertContext = createContext();

export function useGlobalAlert() {
  return useContext(AlertContext);
}

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState({ show: false, message: "", variant: "info" });

  // Show an alert
  const showAlert = useCallback(
    ({ message, variant = "info", timeout = 3000 }) => {
      setAlert({ show: true, message, variant });
      if (timeout > 0) {
        setTimeout(() => setAlert(a => ({ ...a, show: false })), timeout);
      }
    },
    []
  );

  const hideAlert = useCallback(
    () => setAlert(a => ({ ...a, show: false })),
    []
  );

  return (
    <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
      {children}
    </AlertContext.Provider>
  );
}
